import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hamburger\">\n<path d=\"M32 11L8 11L8 13L32 13V11Z\" fill=\"currentColor\" />\n<path d=\"M32 19L8 19L8 21L32 21V19Z\" fill=\"currentColor\" />\n<path d=\"M32 27L8 27L8 29L32 29V27Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol